import React, {useContext} from 'react';
// context
import { RoomContext } from '../context/RoomContext';
//components
import Room from '../components/Room';
//loading
import {SpinnerDotted} from 'spinners-react';

import { useTranslation } from 'react-i18next';

const Rooms = () => {
  const { rooms, loading } = useContext(RoomContext);
  const [t, i18n] = useTranslation("global");
  return (
  <section id='sobeTarget' className='py-24'>
    {/* overlay & spinner */}
    {loading && (
      <div className='h-screen fixed bottom-0 top-0 bg-black/90 w-full z-50 flex justify-center items-center'>
        <SpinnerDotted color='white' />
      </div>
    )}
    <div id='apartmani' className='container mx-auto lg:px-0'>
      <div className='text-center'>
        <div className='font-tertiary uppercase text-[15px] tracking-[6px]'>Dream Apartments & DC Executive Homes</div>
        <h2 className='font-primary text-[45px] mb-4'>{t(`navBarT.apartmani`)}</h2>
      </div>
      
      {/* {grid} */}
      <div className='grid grid-cols-1 max-w-sm mx-auto gap-[30px] lg:grid-cols-2 lg:max-w-none lg:mx-20'>
        {rooms.map((room) => {
          return <Room room={room} key={room.id} />;
        })}
      </div>
      <div id='testimonials'></div>
    </div>
    
  </section>
  )
};

export default Rooms;
